import {useMemo} from 'react';
import {useTranslation} from 'react-i18next';
import styles from './styles.module.css';

const CAMPAIGN_TYPES = ['PRODUCT', 'SERVICE', 'NONE'];

export default function CampaignTypeSelector({
  selectedValue = null,
  isReadOnly = false,
  onSelect,
}) {
  const {t} = useTranslation();

  const options = useMemo(
    () =>
      CAMPAIGN_TYPES.map((type) => ({
        type,
        label: t(`campaignChat.campaignType.${type.toLowerCase()}`),
      })),
    [t],
  );

  return (
    <div className={styles.container}>
      <div className={styles.optionsRow}>
        {options.map((option) => {
          const isSelected = selectedValue === option.type;

          return (
            <button
              key={option.type}
              type="button"
              className={`${styles.optionButton} ${
                isSelected ? styles.optionButtonSelected : ''
              }`}
              onClick={() => {
                if (isReadOnly) {
                  return;
                }
                onSelect?.(option.type, option.label);
              }}
              disabled={isReadOnly}
              aria-pressed={isSelected}
            >
              {option.label}
            </button>
          );
        })}
      </div>
    </div>
  );
}
